import { computed, ComputedRef, ref, watch } from 'vue';

export function useImageChecker(primaryUrl: ComputedRef<string | undefined>, fallbackUrl: ComputedRef<string | undefined>) {
  const isImageAvailable = ref(false);
  const isChecked = ref(false);

  const checkImage = (url: string | undefined) => {
    isImageAvailable.value = false;
    isChecked.value = false;

    if (!url) {
      isImageAvailable.value = false;
      isChecked.value = true;
      return;
    }

    const img = new Image();
    img.onload = () => {
      isImageAvailable.value = true;
      isChecked.value = true;
    };
    img.onerror = () => {
      isImageAvailable.value = false;
      isChecked.value = true;
    };
    img.src = url;
  };

  watch(
    primaryUrl,
    (newUrl) => {
      isChecked.value = false;
      isImageAvailable.value = false;
      checkImage(newUrl);
    },
    { immediate: true }
  );

  const finalUrl = computed(() => {
    if (!isChecked.value) return fallbackUrl.value;
    return isImageAvailable.value ? primaryUrl.value : fallbackUrl.value;
  });

  return { finalUrl, isImageAvailable, isChecked };
}
